import { render, staticRenderFns } from "./CorrectionForm.vue?vue&type=template&id=02d86532&"
import script from "./CorrectionForm.vue?vue&type=script&lang=js&"
export * from "./CorrectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports